var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1594 26.3948C21.7711 27.7406 20.2553 27.5281 18.7962 26.8906C17.2521 26.239 15.8354 26.2106 14.2063 26.8906C12.1664 27.7689 11.0897 27.5139 9.87141 26.3948C2.95824 19.2691 3.97822 8.41772 11.8264 8.02106C13.7388 8.12023 15.0704 9.06937 16.1896 9.15437C17.8612 8.81438 19.462 7.8369 21.247 7.9644C23.3861 8.13439 25.001 8.98437 26.0635 10.5143C21.6436 13.1634 22.6919 18.9858 26.7435 20.6149C25.936 22.7399 24.8877 24.8507 23.1453 26.409L23.1594 26.3948ZM16.0479 7.93606C15.8354 4.77697 18.3995 2.17037 21.3461 1.91537C21.757 5.57029 18.0312 8.29022 16.0479 7.93606Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleFill);
export default __webpack_public_path__ + "static/media/apple_fill.2748814011b8069322f2f6d78a2b81a5.svg";
export { ForwardRef as ReactComponent };